import { autoinject } from "aurelia-framework";
import { AccommodationTypeInfoDTO, AirlineInfoDTO, ApprovalLevelInfoDTO, CityInfoDTO, CountryInfoDTO, EnumModel, OrganisationEntityInfoDTO, TransportationTypeInfoDTO, TravelTypeInfoDTO } from "api/swagger/ApiClient";
import { AccommodationType, Airline, ApprovalLevel, City, Country, OrganisationEntity, TransportType, TravelType } from "model/business-keywords";
import { EnumsService } from 'services/enums-service';

@autoinject
export class BusinessKeywordsMapping {
  constructor(private enumsService: EnumsService) {
  }

  mapToTransportType(dto: TransportationTypeInfoDTO): TransportType {
    return {
      id: dto.id,
      name: dto.name,
      formIcon: dto.icon,
      dataTypeValue: dto.transportationSystemType
    }
  }

  mapToAccommodationType(dto: AccommodationTypeInfoDTO): AccommodationType {
    return {
      id: dto.id,
      name: dto.name,
      formIcon: dto.icon,
      isForHolidayTrip: dto.isForHolidayTrip,
      isForTravelRequest: dto.isForTravelRequest
    }
  }

  mapToCountry(dto: CountryInfoDTO): Country {
    return {
      id: dto.id,
      isoCode2: dto.isoCode2,
      isoCode3: dto.isoCode3,
      name: dto.name,
      formFlag: dto.icon
    }
  }

  mapToCity(dto: CityInfoDTO): City {
    return {
      id: dto.id,
      name: dto.name,
      displayName: dto.displayName,
      region: dto.region,
      country: this.mapToCountry(dto.country)
    }
  }

  mapToApprovalLevel(dto: ApprovalLevelInfoDTO): ApprovalLevel {
    return {
      id: dto.id,
      name: dto.name,
      description: dto.description
    }
  }

  mapToTravelType(dto: TravelTypeInfoDTO): TravelType {
    return {
      id: dto.id,
      name: dto.name
    }
  }

  mapToOrganizationEntity(dto: OrganisationEntityInfoDTO): OrganisationEntity {
    return {
      id: dto.id,
      name: dto.name,
      code: dto.code
    }
  }

  mapToAirline(dto: AirlineInfoDTO): Airline {
    return {
      id: dto.id,
      name: dto.name,
      code: dto.code,
      rating: this.enumsService.airlineRatings.find(x => x.value == dto.airlineRating),
      status: this.enumsService.airlineStatuses.find(x => x.value == dto.airlineStatus),
      comment: dto.comment
    }
  }
}
